import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';
import { makeStyles } from "@utilities/theme_utilities";

interface Props {
  name: string;
  image_url: string;
  disabled?: boolean;
  width?: number;
  height?: number;
  style?: React.CSSProperties | undefined;
  className?: string;
  flashing?: boolean;
  small?: boolean;
  onClick?: ((event: React.MouseEvent<HTMLDivElement>) => void) | null; 
}

export default function ImageButtonBox({ 
  name,
  image_url,
  disabled = false,
  width = -1,
  height = -1,
  style = {},
  className = "",
  flashing = false,
  small = false,
  onClick = null,
}: Props) {
  const [is_flashing, setFlashing] = useState(flashing);
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setFlashing(flashing);
  }, [flashing]);
  
  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        lineHeight: name === "" ? "inherit" : 2.5,
        '&:hover': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.main,
        },
        '&.disabled': {
          color: theme.palette.primary.contrastText,
          backgroundColor: "gray",
        },
        '&:img': {
          filter: "brightness(0) invert(1)"
        }
      },
    });
  });

  const { classes, cx } = useStyles();
  let my_className = `${className} labs_button${is_flashing ? " Flashing" : ""}${is_disabled ? " disabled" : ""}`;
    
  if (small) {
    my_className += " curved_border";
    return (
      <div className="centered"
        style={{
          width: (width > 0 ? `${width}px` : "100%")
        }}>
        <div style={style} 
          className={cx(classes.root, my_className)} 
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            if (!disabled && onClick) {
              onClick(event);
            }
          }}>
          { image_url !== "" &&
            <img src={ image_url } alt={name}
              style={{
                maxWidth: (width > 0 ? `${width}px` : "10em"),
                maxHeight: (height > 0 ? `${height}px` : "10em"),
                border: "1px solid"
              }} 
            />
          }
          { name }
        </div>
      </div>
    )
  } else {
    return (
      <div className="centered"
        style={{
          width: (width > 0 ? `${width}px` : "100%")
        }}>
        <div style={style} 
          className={cx(classes.root, my_className)} 
          onClick={(event: React.MouseEvent<HTMLDivElement>) => {
            if (!disabled && onClick) {
              onClick(event);
            }
          }}>
          <Grid container spacing={0} direction="row">
            { image_url !== "" &&
              <Grid
                size={{
                  xs: 12
                }}>
                <img src={ image_url } alt={name}
                  style={{
                    maxWidth: (width > 0 ? `${width}px` : "10em"),
                    maxHeight: (height > 0 ? `${height}px` : "10em"),
                    border: "1px solid"
                  }} 
                />
              </Grid>
            }
            { name === "" ? null : <Grid
              size={{
                xs: 12
              }}>{ name }</Grid> }
          </Grid>
        </div>
      </div>
    );
  }
}
